import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.modelValue)?_c('div',[_c('div',{staticClass:"text-center"},[_c(VProgressCircular,{attrs:{"color":"red","indeterminate":"","size":"50"}}),_c('p',{staticClass:"ma-0 mt-4"},[_vm._v("Exportando... aguarde.")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }